import { create } from "zustand";
import { cheersApi } from "../api/cheers";

export const CHEER_EVENTS = [
  { key: "comeback",    label: "Back from break",   emoji: null, mascot: "/cheers_images/comeback.png",    title: "Finally back!",         cta: "Get back to work!"  },
  { key: "new_project", label: "New project",       emoji: null, mascot: "/cheers_images/new_project.png", title: "Project kicked off!",   cta: "Start building!"   },
  { key: "new_design",  label: "New design",        emoji: null, mascot: "/cheers_images/new_design.png",  title: "Design created!",       cta: "Bend that blade!"  },
  { key: "release",     label: "Design released",   emoji: null, mascot: "/cheers_images/released.png",     title: "Piece of Art!",  cta: "Keep going!"      },
  { key: "unrelease",   label: "Back to draft",     emoji: null, mascot: "/cheers_images/unrelease.png",   title: "Back to the lab!",      cta: "You can do it!"   },
];

const STORAGE_KEY = "cheers_enabled";

const useCheerStore = create((set, get) => ({
  cheer:   null,   // { eventType, text, subtitle? }
  enabled: localStorage.getItem(STORAGE_KEY) !== "false",

  trigger: async (eventType, subtitle = null) => {
    if (!get().enabled) return;
    try {
      const { data } = await cheersApi.random(eventType);
      if (data.text) {
        set({ cheer: { eventType, text: data.text, subtitle } });
      }
    } catch {
      // silently ignore — cheers are non-critical
    }
  },

  dismiss: () => set({ cheer: null }),

  setEnabled: (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    set({ enabled: value });
  },
}));

export default useCheerStore;
